/**
 * Text helper utilities for AI-generated content display.
 */

/**
 * Strip DOUBLED brand name from AI summary text.
 * Only strips when the name appears twice consecutively at the start.
 *
 * Handles cases like:
 *   "Alassane Doumbia Alassane Doumbia est..."  -> "Alassane Doumbia est..."
 *   "Alassane Doumbia est une personnalite..."   -> "Alassane Doumbia est..." (unchanged)
 *   "Some unrelated text..."                     -> "Some unrelated text..." (unchanged)
 *
 * @param {string} text - The AI summary text
 * @param {string} brandName - The brand/entity name to check for duplication
 * @returns {string} The text with doubled brand name reduced to single
 */
export function stripLeadingBrandName(text, brandName) {
  if (!text || !brandName) return text;
  const trimmed = text.trim();
  const lower = trimmed.toLowerCase();
  const nameLower = brandName.toLowerCase();
  // Only strip if the name appears TWICE consecutively at the start
  if (lower.startsWith(nameLower)) {
    const rest = trimmed.slice(brandName.length).trimStart();
    if (rest.toLowerCase().startsWith(nameLower)) {
      // Double name detected — remove one instance
      return trimmed.slice(0, brandName.length) + ' ' + rest.slice(brandName.length).trimStart();
    }
  }
  return trimmed;
}
